"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTraitsAndVariations = void 0;
const formatTraitsAndVariations = (combinationSelector) => {
    const { traits, variations } = combinationSelector;
    const formattedVariations = {};
    Object.values(variations).forEach((item) => {
        const variationId = item.variationId;
        if (variationId) {
            formattedVariations[variationId] = {
                variationId,
                traits: item.traits || {},
            };
        }
    });
    const formattedTraits = traits.map((trait) => {
        const { name, values } = trait;
        const formattedValues = values.map((value) => {
            const possibleVariations = Object.entries(formattedVariations)
                .filter(([_, variation]) => variation.traits[name] === value.name)
                .map(([variationId]) => variationId);
            return Object.assign(Object.assign({}, value), { possibleVariations, images: value.images || [] });
        });
        return Object.assign(Object.assign({}, trait), { values: formattedValues });
    });
    return {
        traits: formattedTraits,
        variations: formattedVariations,
    };
};
exports.formatTraitsAndVariations = formatTraitsAndVariations;
